var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144 392C121.908 392 104 409.908 104 432S121.908 472 144 472S184 454.092 184 432S166.092 392 144 392ZM207.406 32H112.594C50.5 32 0 82.5 0 144.578V160C0 177.672 14.312 192 32 192S64 177.672 64 160V144.578C64 117.797 85.812 96 112.594 96H207.406C234.188 96 256 117.797 256 144.578C256 162.203 246.438 178.484 231.031 187.062L144.938 234.891C124.625 246.172 112 267.609 112 290.828V320C112 337.672 126.312 352 144 352S176 337.672 176 320V290.828L262.125 243C297.812 223.141 320 185.422 320 144.578C320 82.5 269.5 32 207.406 32Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.7e1eb8ea773b5db8ed1a17b874b07c5f.svg";
export { ForwardRef as ReactComponent };